export default __webpack_public_path__ + "static/media/close.35a0c08d.svg";